import { IndexedDbAssetStore } from './indexeddb-asset-store.ts';

/**
 * The one asset store the app uses.
 *
 * A single instance on purpose: it mints object URLs and reference-counts
 * them, so two instances over the same database would each hold their own
 * counts and release a URL the other was still using.
 *
 * Unlike the document store this is not behind a context — nothing swaps it
 * per-tree, and the sweep at start-up needs the same instance the editor is
 * about to hand to images.
 */
export const assetStore = new IndexedDbAssetStore();
